import React from "react";
import SubscriptionCardHeader from "./SubscriptionCardHeader/SubscriptionCardHeader";
import Loader from "../Loader/Loader";
import SubscriptionCardLabel from "./SubscriptionCardLabel/SubscriptionCardLabel";

import "./styles.css";

const SubscriptionCard = (props) => {
  const subscription = props.sub;
  const {loading, isExpired, addSub, activeSubscription} = props;
  const ticketsCount = subscription.extra + subscription.numOfTickets;

  // const isDoublePrize = props.raffles.length > 1;
  const isDoublePrize = false;

  return (
    <div
      className="subscription-card-body"
      onClick={() => {
        if (!loading && !isExpired) {
          addSub(subscription)();
        }
      }}
    >
    {isDoublePrize ? <SubscriptionCardLabel ticketsAmount={ticketsCount}/> : null}
      <SubscriptionCardHeader
        cost={subscription.totalCost / 100}
        ticketsCount={ticketsCount}
        label={subscription.label ? subscription.label : null}
        isDoublePrize
      />
      <ul className="subscription-card-body__content">
        {subscription.details.map((item, index) => (
          <li key={index}>
            <span>
              <svg
                width="38"
                height="37"
                viewBox="0 0 38 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.0792 35.783C13.5763 35.7858 13.0792 35.6746 12.6254 35.4577C12.1716 35.2409 11.7728 34.9241 11.459 34.5311L2.26099 23.2635C1.8259 22.7305 1.54853 22.0865 1.46021 21.4042C1.37189 20.7219 1.47615 20.0285 1.76121 19.4023C2.04627 18.7762 2.50076 18.2422 3.07334 17.8608C3.64592 17.4793 4.31376 17.2656 5.00141 17.2438C5.04091 17.2426 5.08065 17.2419 5.12022 17.2419C6.03808 17.2414 6.92298 17.584 7.60121 18.2024L13.8397 23.8796C14.0182 24.0419 14.2508 24.1319 14.492 24.132C14.5095 24.132 14.5269 24.1315 14.5444 24.1305C14.6726 24.1236 14.7982 24.0913 14.9138 24.0354C15.0294 23.9795 15.1328 23.9012 15.2179 23.8051L34.3469 2.19213C34.3553 2.1826 34.3635 2.17291 34.3716 2.16305C34.4649 2.04883 34.5808 1.95514 34.712 1.88788C34.8432 1.82061 34.987 1.78123 35.1341 1.77221C35.1598 1.77051 35.1863 1.76954 35.2127 1.76954C35.4865 1.7682 35.7504 1.87206 35.9498 2.05967C36.3152 2.39801 36.4344 2.97446 36.2104 3.31854C36.2066 3.32435 17.0958 34.1023 17.0958 34.1023C16.4385 35.1061 15.4085 35.7167 14.2689 35.7779C14.2057 35.7813 14.1421 35.783 14.0795 35.783H14.0792Z"
                  fill="#DEE965"
                />
                <path
                  d="M35.2134 2.73876C35.228 2.73813 35.2426 2.7407 35.2561 2.74628C35.2697 2.75186 35.2818 2.76032 35.2917 2.77107C35.3191 2.79823 35.3387 2.83218 35.3486 2.86945L16.279 33.5807C15.7856 34.3289 15.0538 34.7654 14.2168 34.8103C14.171 34.8128 14.1247 34.814 14.0791 34.814C13.7201 34.8155 13.3655 34.7357 13.0417 34.5806C12.718 34.4255 12.4336 34.199 12.2099 33.9183L3.01187 22.651C2.691 22.2581 2.48642 21.7832 2.42125 21.2802C2.35607 20.7771 2.4329 20.2658 2.64305 19.8041C2.85319 19.3424 3.18829 18.9487 3.61046 18.6674C4.03263 18.3862 4.52505 18.2286 5.03207 18.2125C5.06164 18.2116 5.09125 18.2112 5.12092 18.2112C5.79751 18.2108 6.44979 18.4634 6.9497 18.9193L13.1882 24.5964C13.5451 24.9211 14.0103 25.1011 14.4928 25.1012C14.5276 25.1012 14.5626 25.1002 14.5978 25.0983C14.8543 25.0845 15.1054 25.0198 15.3366 24.908C15.5679 24.7963 15.7746 24.6397 15.9448 24.4474L35.0734 2.83447C35.0903 2.81541 35.1068 2.79603 35.1229 2.77632C35.1319 2.76451 35.1436 2.755 35.157 2.74856C35.1704 2.74212 35.1851 2.73893 35.1999 2.73925C35.2046 2.73925 35.2092 2.73876 35.2137 2.73876M35.2137 0.800299C35.1652 0.800299 35.1168 0.801915 35.0683 0.805307C34.7891 0.823244 34.5165 0.898619 34.2678 1.02672C34.019 1.15481 33.7993 1.33287 33.6225 1.54976L14.4926 23.1625L8.25404 17.4854C7.39799 16.7035 6.27997 16.2709 5.1206 16.2729C5.0709 16.2729 5.02109 16.2736 4.97117 16.2752C4.10285 16.3028 3.25953 16.5726 2.5365 17.0542C1.81348 17.5359 1.23956 18.2101 0.879592 19.0008C0.519626 19.7915 0.387959 20.6671 0.499468 21.5287C0.610977 22.3903 0.961217 23.2035 1.51062 23.8765L10.7087 35.1438C11.1143 35.6471 11.6278 36.053 12.2113 36.3314C12.7947 36.6097 13.4332 36.7535 14.0797 36.7521C14.1597 36.7521 14.2401 36.75 14.3209 36.7457C15.7765 36.6675 17.0852 35.8951 17.9139 34.6227L37.023 3.84748C37.505 3.10755 37.323 2.0099 36.6087 1.34848C36.2301 0.995033 35.7311 0.799026 35.2131 0.800299H35.2137Z"
                  fill="#DEE965"
                />
              </svg>
            </span>
            {item}
          </li>
        ))}
      </ul>
      <div className="subscription-card-body__footer">
        <button>
          {loading && activeSubscription === subscription ? (
            <>
              <Loader text="adding..." />
            </>
          ) : (
            <>Buy now</>
          )}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCard;
